import moment from "moment";

export const getDateByFormat = (format: string, date: Date) => {
    return moment(date).format(format);
}